import i_vias from './../UI/icons/Sidebar/Vias.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias2.svg'
import i_beneficios from './../UI/icons/Sidebar/Beneficios.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Beneficios2.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades2.svg'
import i_etapas from './../UI/icons/Sidebar/Etapas.svg'
import i_etapas2 from './../UI/icons/Sidebar/Etapas2.svg'
import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/

import i_cocinaSocial from './../UI/icons/Amenities/Cocina Social.svg'
import i_cocinaSocial2 from './../UI/icons/Amenities/Cocina Social_white.svg'
import i_coworking from './../UI/icons/Amenities/Coworking.svg'
import i_coworking2 from './../UI/icons/Amenities/Coworking_white.svg'
import i_Gym from './../UI/icons/Amenities/Gym.svg'
import i_Gym2 from './../UI/icons/Amenities/Gym_white.svg'
import i_Lobby from './../UI/icons/Amenities/Lobby.svg'
import i_Lobby2 from './../UI/icons/Amenities/Lobby_white.svg'
import i_LocalesC from './../UI/icons/Amenities/Locales Comerciales.svg'
import i_LocalesC2 from './../UI/icons/Amenities/Locales Comerciales_white.svg'
import i_PatioC from './../UI/icons/Amenities/Patio Central.svg'
import i_PatioC2 from './../UI/icons/Amenities/Patio Central_white.svg'
import i_PetPark from './../UI/icons/Amenities/PetPark.svg'
import i_PetPark2 from './../UI/icons/Amenities/PetPark_white.svg'
import i_SalonJuegos from './../UI/icons/Amenities/Salon de Juegos.svg'
import i_SalonJuegos2 from './../UI/icons/Amenities/Salon de Juegos_white.svg'
import i_SalonNiños2 from './../UI/icons/Amenities/SalonInfantil.svg'
import i_SalonNiños from './../UI/icons/Amenities/SalonInfantil2.svg'
import i_SalonSocial from './../UI/icons/Amenities/Salon Social.svg'
import i_SalonSocial2 from './../UI/icons/Amenities/Salon Social_white.svg'
import i_SalonBaile from './../UI/icons/Amenities/SalonBaile.svg'
import i_SalonBaile2 from './../UI/icons/Amenities/SalonBaile2.svg'
import i_Spa from './../UI/icons/Amenities/Spa.svg'
import i_Spa2 from './../UI/icons/Amenities/Spa_white.svg'
import i_Piscina from './../UI/icons/Amenities/piscina.svg'
import i_Piscina2 from './../UI/icons/Amenities/piscina2.svg'


/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_otros from './../UI/icons/POI/Otros.svg'
import i_colegios from './../UI/icons/POI/Educacion2.svg'
import i_parques from './../UI/icons/POI/Parques.svg'
import i_bancos from './../UI/icons/POI/Bancos.svg'
import i_bancos2 from './../UI/icons/POI/Bancos_White.svg'
import i_salud2 from './../UI/icons/POI/Salud_White.svg'
import i_otros2 from './../UI/icons/POI/Otros_White.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques_White.svg'
import i_restaurante from './../UI/icons/POI/Restaurantes.svg'
import i_restaurante2 from './../UI/icons/POI/Restaurantes_White.svg'


let icons = {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Amenidades*/
    'Cocina Social': i_cocinaSocial,
    'Cocina Social2': i_cocinaSocial2,
    'Salón de Niños': i_SalonNiños,
    'Salón de Niños2': i_SalonNiños2,
    'Coworking': i_coworking,
    'Coworking2': i_coworking2,
    'Gimnasio': i_Gym,
    'Gimnasio2': i_Gym2,
    'Lobby': i_Lobby,
    'Lobby2': i_Lobby2,
    'Locales Comerciales': i_LocalesC,
    'Locales Comerciales2': i_LocalesC2,
    'Parque Infantil': i_PatioC,
    'Parque Infantil2': i_PatioC2,
    'Spa': i_Spa,
    'Spa2': i_Spa2,
    'Spa para Mascotas': i_PetPark,
    'Spa para Mascotas2': i_PetPark2,
    'Salón de Juegos': i_SalonJuegos,
    'Salón de Juegos2': i_SalonJuegos2,
    'Salón Social': i_SalonSocial,
    'Salón Social2': i_SalonSocial2,
    'Salón de Baile' : i_SalonBaile2,
    'Salón de Baile2' : i_SalonBaile,
    'Piscina' : i_Piscina,
    'Piscina2' : i_Piscina2,

    /**/
    "Salud ": i_salud,
    "Salud 2": i_salud2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Colegios": i_colegios,
    "Colegios2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
    'Restaurantes': i_restaurante,
    'Restaurantes2': i_restaurante2,
    'Sector Bancario' : i_bancos,
    'Sector Bancario2' : i_bancos2,


}

export default icons